import useAxios from 'axios-hooks'
import { getPcekZone } from '@entities/user'
import { reqHeaders } from '@shared/config'
import { baseUmpPath } from '@root/api/api'
import { TspPageDenominationParam } from '@entities/tsp/model/tsp.types'

export interface GetPriceResp {
  price?: string
}

type DenominationWithPriceParams = {
  params?: TspPageDenominationParam[]
} | null

export const useGetPrice = (activeDenomination: DenominationWithPriceParams) => {
  const zone = getPcekZone()

  // Вытаскивает parthnerId и serviceCode текущего номинала, если он есть
  const activeDenominationParams =
    // process.env.NODE_ENV !== 'development'
    activeDenomination?.params?.reduce((acc, param) => ({ ...acc, [param.name]: { value: param.defaultValue } }), {
      partnerId: { value: '' },
      serviceCode: { value: '' },
    }) || null
  // : {
  //     partnerId: { value: 'fwk' },
  //     serviceCode: { value: '84' },
  //   }

  const [{ data: priceData, loading: isGetPriceLoading, error: isPriceError }, getPrice, cancelPriceRequest] =
    useAxios<GetPriceResp>(
      {
        url: `${baseUmpPath}/${zone}/games/getPrice?serviceCode=${activeDenominationParams?.serviceCode.value}&partner=${activeDenominationParams?.partnerId.value}`,
        headers: { ...reqHeaders },
      },
      { manual: true }
    )

  return { getPrice, cancelPriceRequest, activeDenominationParams, isPriceError, isGetPriceLoading, priceData }
}
